<template>
    <div class="app-dashboard">

        <br>

        <mu-loading v-if="chart.loading" text="Aguarde... Estamos atualizando os dados do gráfico..."></mu-loading>

        <mu-row gutter v-bind:class="{ 'opacity': chart.loading }">
            <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                <div class="chart-line">
                    <h3>Envios dos últimos <u>{{ chart.days }}</u> dias</h3>
                    <mu-chart-line v-if="!chart.loading" :ref="chart.days" :data="chart.data" :options="chart.options" :height="chart.height"></mu-chart-line>
                </div>
            </mu-col>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <div class="services">
                    <h3>Custo dos últimos:</h3>
                    <mu-select v-model="chart.days" full-width @change="loadChart(chart.days)">
                        <mu-option label="10 Dias" :value="10"></mu-option>
                        <mu-option label="20 Dias" :value="20"></mu-option>
                        <mu-option label="30 Dias" :value="30"></mu-option>
                    </mu-select>
                    <table>
                        <thead>
                            <tr>
                                <th>Serviço</th>
                                <th class="is-center">Quantidade</th>
                                <!-- <th class="is-center" v-if="user && user.permition != 'U'">Custo</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, key) in chart.getService" :key="key">
                                <td><mu-dot :color="chart.colors[key]"></mu-dot> {{ item.name }}</td>
                                <td class="is-center">{{ item.quantity }}</td>
                                <!-- <td class="is-center" v-if="user && user.permition != 'U'">{{ priceFormat(item.cost) }}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="balance" v-if="company && (company.signatureType == 'P' || company.signatureType == 'T')">
                    <!-- Balance -->
                    <mu-my-balance title="Saldo dos serviços contratados"></mu-my-balance>
                </div>
            </mu-col>
        </mu-row>

        <br>

        <mu-row gutter>
            <mu-col span="12" sm="4" md="4" lg="4" xl="4">
                <mu-sms-shooting></mu-sms-shooting>
            </mu-col>
            <mu-col span="12" sm="4" md="4" lg="4" xl="4">
                <mu-flex justify-content="start" align-items="center" class="shortcut shortcut-campaign">
                    <div class="icon">
                        <img src="/svg/dashboard/campaign.svg" />
                    </div>
                    <div class="content">
                        Última campanha<br>
                        <div v-if="campaign.item">
                            <router-link :to="{ name: 'app.services.sms.details', params: { id: campaign.item.id } }">
                                <strong><u>{{ campaign.item.title }}</u></strong><br>
                            </router-link>
                            <span>{{ textDate(campaign.item) }}</span>
                        </div>
                    </div>
                </mu-flex>
            </mu-col>
            <mu-col span="12" sm="4" md="4" lg="4" xl="4">
                <mu-flex justify-content="start" align-items="center" class="shortcut shortcut-favorites">
                    <div class="icon">
                        <img src="/svg/dashboard/favorite.svg" />
                    </div>
                    <div class="content">
                        Favoritos<br>
                        <span v-for="(item, key) in shortcuts" :key="key">
                            <router-link :to="{ name: item.route }">{{ item.title }}</router-link>
                            <br v-if="key==1">
                        </span>
                        <span v-if="shortcuts.length == 0">
                            <router-link :to="{ name: 'app.profile' }">Adicionar Favoritos</router-link>
                        </span>
                    </div>
                </mu-flex>
            </mu-col>
        </mu-row>

    </div>
</template>

<script>
    import Menu from '@/config/menu'
    import ProfileServices from '@/services/profile/user'
    import CampaignServices from '@/services/dashboards/campaign'
    import ChartServices from '@/services/dashboards/chart'
    import moment from 'moment'
    import momentTimezone from 'moment-timezone'

    export default {
        name: 'app-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                chart: {
                    data: {},
                    getService: [],
                    getTotal: 0,
                    colors: ['#19c462', '#36a2eb', '#ff9f40', '#ff6384'],
                    backgroundColor: ['rgba(25, 196, 98, 0.10)', 'rgba(54, 162, 235, 0.10)', 'rgba(255, 159, 64, 0.10)', 'rgba(255, 99, 132, 0.10)'],
                    days: 10,
                    height: 180,
                    loading: false,
                    options: {
                        legend: false,
                        tooltips: {
                            cornerRadius: 3
                        },
                        elements: {
                            line: {
                                tension: 0
                            }
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        suggestedMin: 0,
                                        suggestedMax: 50
                                    }
                                }
                            ]
                        }
                    }
                },
                sms: {
                    visible: false
                },
                campaign: {
                    loading: false,
                    item: {}
                },
                shortcuts: []
            }
        },

        computed: {
            quantity () {
                return this.chart.days
            },
            user () {
                return this.$store.state.user || null
            },
            company () {
                return this.$store.state.company || null
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        async created () {
            await this.loadChart()
            await this.loadShortcuts()
            await this.loadCampaign()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            async loadRefreshData (days) {
                await this.loadChart(days)
            },

            /**
             * Carregando os dados para popular o gráfico e tabelas
             */
            async loadChart (days) {
                try {
                    days = days || this.chart.days
                    this.chart.loading = true

                    let result = await ChartServices.serviceUsage(this.chart.days)

                    if (result && result.status) {
                        await this.fillDataProcess(result.results)
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados do gráfico.')
                } finally {
                    this.chart.loading = false
                }
            },

            /**
             * Organizando os dados datalabels e datasets para o gráfico
             */
            async fillDataProcess (data) {
                this.chart.getService = await this.countServices(data)
                this.chart.getTotal = await this.countTotal(data)

                this.fillSuggestMax(data)

                let labels = await this.fillDataLabels(data)
                let datasets = await this.fillDataSets(data)

                this.chart.data = {
                    labels,
                    datasets
                }
            },

            /**
             * Formatando um array com os datalabels das datas
             */
            fillDataLabels (data) {
                let first = data.find((item) => {
                    return item
                })
                if (!first) {
                    return []
                }
                let dates = first.dates.map((item) => {
                    return this.getDate(item.date)
                })

                return dates.reverse()
            },

            /**
             * Formatando um array com os datasets para o gráfico
             */
            fillDataSets (data) {
                let count = -1
                return data.map((item) => {
                    item.dates.reverse()
                    const arrayDates = item.dates.map((d) => {
                        return d.quantity
                    })
                    count++
                    return {
                        label: item.name,
                        data: arrayDates,
                        borderWidth: 2,
                        backgroundColor: this.chart.backgroundColor[count],
                        borderColor: this.chart.colors[count]
                    }
                })
            },

            /**
             * Formatando a altura máxima do gráfico de acordo com os dados
             */
            fillSuggestMax (data) {
                data.map((item) => {
                    let valor = 0
                    item.dates.map((d) => {
                        if (d.quantity > valor) {
                            valor = d.quantity
                        }
                        return d.quantity
                    })
                    this.chart.options.scales = {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: valor + Math.ceil(valor * 0.2)
                                }
                            }
                        ]
                    }
                })
            },

            countServices (data) {
                return data.map((item) => {
                    const quantity = item.dates.reduce((total, item) => {
                        return total + item.quantity
                    }, 0)

                    const cost = item.dates.reduce((total, item) => {
                        return total + item.tax
                    }, 0)

                    return {
                        name: item.name,
                        quantity,
                        cost
                    }
                })
            },

            countTotal (data) {
                return data.reduce((total, item) => {
                    const cost = item.dates.reduce((t, i) => {
                        return t + i.tax
                    }, 0)

                    return total + cost
                }, 0)
            },

            /**
             * Carrega a última campanha enviada pelo cliente
             */
            async loadCampaign () {
                try {
                    this.campaign.loading = true

                    let result = await CampaignServices.findLast()

                    if (result && result.status) {
                        this.campaign.item = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar a última campanha.')
                } finally {
                    this.campaign.loading = false
                }
            },

            /**
             * Verifica que texto gravar junto com a data
             */
            textDate (item) {
                if (!item) return ''

                if (item.scheluded_to === null) {
                    if (item.sented_at) {
                        return `Enviado em ${momentTimezone.utc(item.sented_at).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')}`
                    }
                }

                return `Agendado em ${moment(item.scheluded_to || item.sented_at).format('DD/MM/YYYY HH:mm')}`
            },

            /**
             * Retorna uma data no formato DD/MM
             */
            getDate (value) {
                return moment(value).format('DD/MM')
            },

            /**
             * Carrega os os atalhos do usuário
             */
            async loadShortcuts () {
                try {
                    let result = await ProfileServices.find()

                    if (result && result.status) {
                        this.shortcuts = await Menu.findByKeys(JSON.parse(result.results.shortcuts || '[]'))
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .app-dashboard

        padding-bottom 15px

        .opacity
            opacity 0.3

        .is-left
            text-align left

        .is-center
            text-align center

        .is-right
            text-align right

        .chart-line
            min-height 200px
            h3
                font-weight 100
                text-align center
                margin 0 0 10px 0

        .filter
            margin-bottom 0

        .services
            margin-bottom 20px

        .services, .balance
            table
                width 100%
                border-collapse collapse
                text-align left
                th, td
                    font-size 11px
                    padding 5px 5px 2px 5px
                    border-bottom 1px #e0e0e0 solid
                    border-left 1px #e0e0e0 solid
                    border-right 1px #e0e0e0 solid
                thead
                    background #dddddd
                    border-bottom 1px #c2c2c2 solid
                    th
                        color #656569
                        font-weight normal

            .mu-input
                margin-bottom 0

            h3
                font-size 15px
                margin 0

        .shortcut
            padding 15px
            overflow auto
            margin-top 15px
            background lighten($grey, 80%)
            border-radius 5px
            border 1px lighten($grey, 40%) dotted

            img
                width 85%

            div
                float left
                &.icon
                    width 25%
                &.content
                    width 75%

            &.shortcut-campaign
                font-size 11px
                strong
                    font-size 12px
                    color $primary
                span
                    font-size 11px
                    opacity 0.7

            &.shortcut-favorites
                font-size 11px
                span
                    a
                        font-size 12px
                        font-weight bold
                        color $primary
                        text-decoration underline
                        margin-right 20px
                        &:hover
                            color $secondary

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .app-dashboard
            padding-bottom 0

            .shortcut
                margin-top 0

</style>
